<template>
  <div>
    <v-toolbar
      color="theme_primary"
      dark
      extension-height="36"
      height="36"
      flat
      app
    >
      <v-toolbar-side-icon @click="drawerToggle()">
        <v-icon>{{ drawerIcon() }}</v-icon>
      </v-toolbar-side-icon>
      <v-layout align-center>
        <v-icon size="12" left>store</v-icon>
        <v-breadcrumbs
          :items="[
            {
              exact: true,
              text: 'Companies',
              disabled: false,
              to: '/companies',
            },
          ]"
          dark
        >
          <template v-slot:divider>
            <v-icon>chevron_right</v-icon>
          </template>
        </v-breadcrumbs>

        <v-icon>chevron_right</v-icon>
        <span class="breadcrumb_current_page">{{ pageTitle }}</span>

        <!-- <v-layout justify-end>
          <v-tooltip bottom v-if="!newCompany.id">
            <v-btn
              slot="activator"
              depressed
              fab
              flat
              small
              @click="save"
              color="green"
              class="white--text"
              :disabled="!clickable"
            >
              <v-icon>save</v-icon>
            </v-btn>
            <span>Save</span>
          </v-tooltip> -->

          <!-- Delete is now in basic infos.vue -->
          <!-- <v-tooltip bottom>
            <destroyModale
              slot="activator"
              resourceName="company"
              v-if="newCompany.id"
              :itemId="newCompany.id"
              warningText="You are going to remove this Company and its associated contacts and products permanently"
              redirectRoute="companies"
              :fab="true"
              :show_label="false"
              :flat="true"
              :small="true"
            />
            <span>Delete</span>
          </v-tooltip>-->
        <!-- </v-layout> -->
        <v-spacer></v-spacer>
        <headerProfile />
      </v-layout>
    </v-toolbar>
    <v-toolbar color="grey lighten-3" flat height="36"  >
      <v-layout column align-center justify-center py-2 class="text-xs-center">
        <v-autocomplete
          v-if="!this.loading && newCompany.id"
          :items="companies"
          item-value="id"
          item-text="name"
          solo
          height="36"
          background-color="transparent"
          label="Select a company"
          browser-autocomplete="gepaij"
          :value="newCompany.id"
          dense
          flat
          single-line
          @change="redirectToCompany($event)"
        >
          <template slot="prepend">
            <v-avatar
              v-if="newCompany.logo_url"
              size="18"
              style="position: relative; top: 3px; right: -8px;"
            >
              <img :src="s3bucket + '/' + newCompany.logo_url" />
            </v-avatar>
          </template>
        </v-autocomplete>
        <span v-if="!this.loading && !newCompany.id">New Company Form</span>
      </v-layout>
    </v-toolbar>

    <v-container fluid fill-height class="pt-2">
      <v-layout row align-center justify-center>
        <v-card max-width="1280" width="100%" flat>
          <!-- PAGE TITLE -->

          <v-tabs v-model="tab" fixed-tabs v-if="!loading">
            <v-tab href="#basic-info">
              <v-icon small class="pr-2">info</v-icon>PROFILE
            </v-tab>
            <!-- <v-tab href="#company-type" v-if="companyType == ''">
              <v-icon small color="error" class="pr-2">warning</v-icon>
              <span class="text-uppercase error--text font-weight-bold"
                >SETTINGS</span
              >
            </v-tab> -->
            <v-tab href="#company-type" :disabled="!newCompany.id">
              <v-icon small class="pr-2">settings</v-icon>
              <span class="text-uppercase">SETTINGS</span>
            </v-tab>

            <v-tab href="#commercial-contacts" :disabled="!newCompany.id">
              <v-icon small class="pr-2">contact_phone</v-icon>COMMERCIALS
            </v-tab>

            <v-tab href="#logistic-contacts" :disabled="!newCompany.id">
              <v-icon small class="pr-2">contact_mail</v-icon>LOGISTICS
            </v-tab>

            <v-tab href="#executive-contacts" :disabled="!newCompany.id">
              <v-icon small class="pr-2">security</v-icon>ADMINS
            </v-tab>

            <!-- <v-tab href="#supplier" v-if="!newCompany.isCustomer && !newCompany.isSubsidiary">
              <v-icon small class="pr-2">flight_takeoff</v-icon>SUPPLIER
            </v-tab>

            <v-tab href="#customer" v-if="!newCompany.isSupplier && !newCompany.isSubsidiary">
              <v-icon small class="pr-2">flight_land</v-icon>CUSTOMER
            </v-tab>

            <v-tab
              href="#subsidiary"
              v-if="
              currentUserCan('see', 'subsidiary_tabs') &&
                (!newCompany.isCustomer && !newCompany.isSupplier)
            "
            >
              <v-icon small class="pr-2">store</v-icon>SUBSIDIARY
            </v-tab>-->
          </v-tabs>

          <v-tabs-items v-model="tab" v-if="!loading">
            <v-tab-item value="basic-info" lazy>
              <v-layout row wrap justify-center>
                <v-flex xs12 sm12 md12 lg10>
                  <basicInfos @companyCreated="companyCreated()"/>
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item :disabled="!companyType" value="company-type" lazy>
              <v-layout row wrap justify-center>
                <v-flex xs12 sm12 md12 lg10>
                  <companyTypeSettings />
                </v-flex>
              </v-layout>
            </v-tab-item>
            <v-tab-item value="commercial-contacts" lazy>
              <v-flex px-4 pt-2>
                <companyContacts contactType="commercial" />
              </v-flex>
            </v-tab-item>
            <v-tab-item value="logistic-contacts" lazy>
              <v-flex px-4 pt-2>
                <companyContacts contactType="logistic" />
              </v-flex>
            </v-tab-item>
            <v-tab-item value="executive-contacts" lazy>
              <v-flex px-4 pt-2>
                <companyContacts contactType="executive_accounting" />
              </v-flex>
            </v-tab-item>

            <!-- <v-tab-item value="supplier" lazy>
              <supplier />
            </v-tab-item>
            <v-tab-item value="customer" lazy>
              <customer />
            </v-tab-item>
            <v-tab-item value="subsidiary" lazy>
              <subsidiary />
            </v-tab-item> -->
          </v-tabs-items>
        </v-card>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import basicInfos from "../components/companies/basicInfos";
import customer from "../components/companies/customer";
import subsidiary from "../components/companies/subsidiary";
import supplier from "../components/companies/supplier";
import companyTypeSettings from "../components/companies/companyTypeSettings";
import companyContacts from "../components/companies/companyContacts.vue";
import loadingSpinner from "../components/layout/Loading";
import headerProfile from "../components/shared/headerProfile";

import CREATE_COMPANY from "../graphql/companies/create.gql";
import UPDATE_COMPANY from "../graphql/companies/update.gql";
import SHOW_COMPANY from "../graphql/companies/show.gql";

export default {
  data() {
    return {
      dialog: false,
      tab: "basic-info",
      isClickable: true,
      tmpCompany: {},
      s3bucket: process.env.VUE_APP_S3_BUCKET_URL,
    };
  },
  components: {
    loadingSpinner,
    basicInfos,
    customer,
    subsidiary,
    supplier,
    companyContacts,
    headerProfile,
    companyTypeSettings,
  },
  computed: {
    ...mapGetters("companyStore", ["newCompany"]),
    ...mapGetters("commonStore", ["loading", "companies"]),
    pageTitle() {
      if (this.$route.params.id) return `${this.newCompany.name}`;
      else return "Company creation";
    },
    isCreateForm() {
      return !this.$route.params.id;
    },
    clickable() {
      return this.isClickable;
    },
    companyType() {
      if (this.newCompany.isSupplier) {
        return "supplier";
      }
      if (this.newCompany.isCustomer) {
        return "customer";
      }
      if (this.newCompany.isSubsidiary) {
        return "subsidiary";
      }

      return "";
    },
  },
  methods: {
    redirectToCompany(item) {
      this.$router.push({
        name: "company",
        params: {
          id: item,
        },
      });
      this.reset();
    },
    fetchAndSubscribeToCompany(id) {
      this.fetchAndSubscribe(
        SHOW_COMPANY,
        { id: id },
        "companyStore",
        "newCompany"
      ).then((data) => {
        this.tmpCompany = JSON.parse(JSON.stringify(data.company));
        if (this.tmpCompany.subsidiary)
          delete this.tmpCompany.subsidiary.bank_informations;

        if (this.tmpCompany.customer)
          delete this.tmpCompany.customer.documentary_instructions;
      });
    },
    isValidURL(str) {
      var regex = /^(http:\/\/|https:\/\/)?((([a-zd]([a-zd-]*[a-zd])*).)+[a-z]{2,}|((d{1,3}.){3}d{1,3}))(:d+)?(\/[-a-zd%_.~+]*)*([;&a-zd%_.~+=-]*)?(#[-a-zd_]*)?$/;
      if (!regex.test(str)) {
        return false;
      } else {
        return true;
      }
    },
    fetchNewCompanyObject() {
      let objectToSave = JSON.parse(JSON.stringify(this.newCompany));

      if (objectToSave.subsidiary)
        delete objectToSave.subsidiary.bank_informations;

      if (objectToSave.customer)
        delete objectToSave.customer.documentary_instructions;

      return objectToSave;
    },

    save() {
      const objectToSave = this.fetchNewCompanyObject();

      if (
        objectToSave.website != "" &&
        !this.isValidURL(objectToSave.website)
      ) {
        return this.showError("Enter a valid url for field website");
      }

      this.isClickable = false;

      if (objectToSave.id) {
        this.sendMutation("updated", "company", UPDATE_COMPANY, objectToSave)
          .then(() => {
            this.tmpCompany = this.newCompany;
            this.isClickable = true;
          })
          .catch(() => {
            this.isClickable = true;
          });
      } else {
        this.sendMutation("created", "company", CREATE_COMPANY, objectToSave)
          .then((mutation_return) => {
            const id = mutation_return.create_company.id;
            this.fetchAndSubscribeToCompany(id);
            this.tmpCompany = this.newCompany;
            this.$router.replace({
              name: "company",
              params: { id: id },
            });
            this.isClickable = true;
          })
          .catch(() => {
            this.isClickable = true;
          });
      }
    },
    reset() {
      if (this.$route.params.id)
        this.fetchAndSubscribeToCompany(this.$route.params.id);
      else this.$store.dispatch("companyStore/resetCompanyCreation");
    },

    companyCreated() {
     this.reset();
     this.tab = "company-type"
    },
  },
  created() {
    this.tab = "basic-info";
    if (!this.$route.params.id && this.newCompany.id)
      this.$store.dispatch("companyStore/resetCompanyCreation");
    else if (this.$route.params.id)
      this.fetchAndSubscribeToCompany(this.$route.params.id);
  },
  beforeDestroy() {
    this.unsubscribe("newCompany");
  },
};
</script>
